import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let sevenPost = window.sessionStorage.getItem('domain')
const store = new Vuex.Store({
    state: {
        sevenPost:sevenPost,
        userInfo:{}
    },
})
Vue.use(store)
export default store



// WEBPACK FOOTER //
// ./src/store.js